import { Action } from '@ngrx/store';

export enum EquipmentActionType {
  ADD_ITEM = '[ARTICLE] Add ARTICLE',
}

export class AddEquipmentAction implements Action {

  readonly type = EquipmentActionType.ADD_ITEM;
  constructor(public payload: any) { }

}

export type EqipmentAction = AddEquipmentAction;